import { Icon } from 'core-ui';
import { Svg } from 'src/assets/icons/SettingIcon/svg';
import { CustomIconComponentProps } from 'src/models/icon';

export const SettingIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
);
